import cn from 'classnames'
import React from 'react'

import styles from './Search.module.scss'

import LoupeIcon from '~shared/icons/16/loupe.svg'

interface SearchProps {
  value?: string
  defaultValue?: string
  placeholder?: string
  className?: string
  disabled?: boolean
  onChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void
  onFocus?: (ev: React.FocusEvent<HTMLInputElement>) => void
  onBlur?: (ev: React.FocusEvent<HTMLInputElement>) => void
}

function Search(
  { value, defaultValue, placeholder, className, disabled, onChange, onBlur, onFocus, ...props }: SearchProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  return (
    <label className={cn(styles.root, className)} {...props}>
      <span className={styles.icon}>
        <LoupeIcon />
      </span>

      <input
        type="search"
        ref={ref}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        className={styles.input}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </label>
  )
}

export default React.forwardRef<HTMLInputElement, SearchProps>(Search)
